<div [ngClass]="{'card widget-card': card(), 'error-card': error()}" class="h-full {{cardClass()}}">
  <ng-content select="[header]" class="card-header flex"></ng-content>
  <ng-content select="[selectText]" class="byTextSelect"></ng-content>
  @if (!error()) {
    <ng-content></ng-content>
  }
  @else {
    <div class="widget-error">
      <span class="error-message" data-cy="errorMessage">{{error()}}</span>
    </div>
  }
</div>